import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// category
const CategoryDetailPage = lazy(() => import('src/pages/dashboard/category-detail'));
// ----------------------------------------------------------------------

export const categoryRoutes = [
  {
    path: 'category',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <CategoryDetailPage />, index: true },
      {
        path: ':id',
        element: <CategoryDetailPage />,
      },
    ],
  },
];
